import { render } from "./TramiteFormCarga.vue?vue&type=template&id=399983e0&scoped=true"
import script from "./TramiteFormCarga.vue?vue&type=script&lang=js"
export * from "./TramiteFormCarga.vue?vue&type=script&lang=js"

import "@/assets/css/tabs.css?vue&type=style&index=0&id=399983e0&scoped=true&lang=css"
import "./TramiteFormCarga.vue?vue&type=style&index=1&id=399983e0&scoped=true&lang=css"
import "./TramiteFormCarga.vue?vue&type=style&index=2&id=399983e0&scoped=true&lang=css"
import "./TramiteFormCarga.vue?vue&type=style&index=3&id=399983e0&scoped=true&lang=css"
import "./TramiteFormCarga.vue?vue&type=style&index=4&id=399983e0&scoped=true&lang=css"
import "./TramiteFormCarga.vue?vue&type=style&index=5&id=399983e0&scoped=true&lang=css"
import "./TramiteFormCarga.vue?vue&type=style&index=6&id=399983e0&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-399983e0"]])

export default __exports__